module.exports = __webpack_public_path__ + "static/media/card_2x.83ca2b26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/silicon-valley/card_2x.jpg
// module id = 958
// module chunks = 27